import type { UserConsent } from './user-consent.model';

export function transformUserConsent(userConsent: UserConsent): UserConsent {
  return {
    id: userConsent.id,
    dataType: userConsent.dataType,
    usageType: userConsent.usageType,
    consentGiven: userConsent.consentGiven,
    collectionLocation: userConsent.collectionLocation,
    dateCreated: userConsent.dateCreated * 1000,
  };
}
